import { createContext, useContext } from "react";

export const Context = createContext(undefined)

export const ContextProvider = Context.Provider;
export const ContextConsumer = Context.Consumer;

export const useSitecoreContext = () => useContext(Context);
